export default __webpack_public_path__ + "static/media/logo_viaweb_horizontal.411b1990.png";